import React, { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import SeriesQr from './SeriesQr'
import QrCodeIcon from '@mui/icons-material/QrCode';
import LineWeightIcon from '@mui/icons-material/LineWeight';

const SeriesQrGet = ({ seriesId, type }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                type && type === 'barcode' ?
                    <LineWeightIcon />
                :
                    <QrCodeIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={
                type && type === 'barcode' ? 
                    'Отримати Щтрих-код серії'
                : 
                    'Отримати QR-код серії'
            }
            disableClickOutside={true}
            content={
                <SeriesQr
					seriesId={seriesId}
                    setOpen={setOpen}
                    type={type}
                />
            }
        />
    </>
  )
}

export default SeriesQrGet